import React, {Component} from 'react';
import AccountInput from '../../inputs/AccountInput';
import AgencyInput from '../../inputs/AgencyInput';
import HourInput from '../../inputs/HourInput';
import CepInput from '../../inputs/CepInput';

class HourLine extends Component{
    createInputs(){
        let inputs = [];
        for(let i = 0; i < 4; i++){
            inputs.push(
            <HourInput
                disabled={!this.props.enabled}
                id={i} 
                class="form-control" 
                divStyle={{flex:"1"}}
                style={{boxShadow: "0px 0px 0px", borderRadius: 0, border: 0,
                        borderBottom: "1px solid #ced4da", borderRight: "1px solid #ced4da",
                        textAlign: "center"}}
                onChange={this.props.onChange} 
                value={!this.props.enabled ? "" :this.props.data[i]}
                />
            )
        }

        return inputs;
    }

    render(){
        return(
            <div style={{display:"flex", width:"80%", marginBottom:5}}>
                <div  className="checkbox checkbox-circle checkbox-client-default ai-c" style={{flex:1}}>
                    <input checked={this.props.enabled} id={this.props.mode + "toggle" + this.props.label} type="checkbox"/>
                    <label onClick={this.props.toggle} for={this.props.mode + "toggle" + this.props.label} className="ai-c">{this.props.label}:</label>
                </div>
                {this.createInputs()}
            </div>
        )
    }
}

class FisioterapistTimes extends Component{
    state = {
        labels:["Todos","Seg","Ter","Qua","Qui","Sex","Sab","Dom"]
    }

    componentWillMount(){
        let lines = [];
        let lineEnabled = [];
        this.state.labels.forEach((day, i) =>{
            const existingInterval = this.props.intervals[this.props.id + "-" + i];

            if(existingInterval){
                lines.push(existingInterval.split("-"));
                lineEnabled.push(true);
            }else{
                lines.push(["07:00","12:00","14:00","17:00"]);
                lineEnabled.push(false);
            }
        })

        this.setState({lines:lines, lineEnabled:lineEnabled}, () => this.saveChanges());
    }

    saveChanges(){
        let interval = {};
        this.state.lines.forEach((line,i) =>{
            if(this.state.lineEnabled[i]) interval[this.props.id + "-" + i] = line[0] + "-" + line[1] + "-" + line[2] + "-" + line[3];
        });

        this.props.onChange({target:{id:"intervals" + this.props.id, value:interval}});
    }

    changeAll(event){
        let lines = this.state.lines;
        this.state.labels.forEach((day, i) =>{
            lines[i][event.target.id] = event.target.value;
        });

        this.setState({lines:lines}, () => this.saveChanges());
    }

    changeTime(lineNum,event){
        let line = this.state.lines[lineNum];
        let value = event.target.value == "" ? "SEMHORARIO" : event.target.value;
        
        line[event.target.id] = value;

        this.state.lines[lineNum] = line;

        this.saveChanges();
    }

    toggleAll(){
        let enabled = !this.state.lineEnabled[0];
        let lineEnabled = this.state.lineEnabled;
        for(let i = 0; i < lineEnabled.length; i++){
            lineEnabled[i] = enabled;
        }

        this.setState({lineEnabled:lineEnabled});
    }

    toggleLine(lineNum){
        let lineEnabled = this.state.lineEnabled;
        lineEnabled[lineNum] = !lineEnabled[lineNum];

        this.setState({lineEnabled:lineEnabled}, () => this.saveChanges());
    }

    createLines(){
        let content = []
        this.state.labels.forEach((day,i) =>{
            content.push(<HourLine
                mode = {this.props.id} 
                enabled={(i == 0 ? true : this.state.lineEnabled[i]) && this.props.enabled}
                toggle={i == 0 ? null :() => this.toggleLine(i)}
                label={day} 
                key={i} 
                onChange={i == 0 ? (e) => this.changeAll(e) : (e) => this.changeTime(i,e)} 
                data={this.state.lines[i]}/>)
        })

        return content;
    }

    render(){
        return(
            <div>
                {this.createLines()}
            </div>
        )
    }
}

export class FisioterapistsAgenda extends Component{
    state = {
        clinicEnabled:false,
        homeEnabled: false,
    }

    render(){
        return(
            <div class="pY-20 acount-form">
                <div class="mB-30 mT-30">
                    <div class="form-group col-md-12 p-0">
                        <div class="col-sm-12 mT-30 p-0">
                            <div class="peers jc-sb ai-c mT-10 col-md-12">
                                <h5 class="m-0 p-0">
                                    <b>Horários de atendimento</b>
                                </h5>
                            </div>
                            <div class="col-md-12 m-0 p-0">
                                <div class="col-md-6 m-0 p-0">
                                    <div class=" p-0 mT-10 col-md-12">

                                        <label>Está disponível para <b>atendimento na clínica?</b></label>
                                        <div class="peers">
                                            <div class="radio radio-client-default m-0 pX-10 mL-30 mT-20">
                                                <input checked={this.props.data.clinicEnabled} onClick={() => this.props.onChange({target:{id:"clinicEnabled",value:true}})} type="radio" name="forma-s" id="clinica-radio-1" value="yes"/>
                                                <label for="clinica-radio-1">SIM</label>
                                            </div>
                                            <div class="radio radio-client-default m-0 pX-10 mL-30  mT-20">
                                                <input checked={!this.props.data.clinicEnabled} onClick={() => this.props.onChange({target:{id:"clinicEnabled",value:false}})} type="radio" name="forma-n" id="clinica-radio-2" value="no"/>
                                                <label for="clinica-radio-2">NÃO</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class=" p-0 mT-10 col-md-12">
                                        <label>Qual unidade blues?</label>
                                        <div class="form-group mB-10 col-sm-6 w-100p">
                                            <div class="checkbox checkbox-circle checkbox-client-default ai-c">
                                                <input disabled={!this.props.data.clinicEnabled} id="Rio" name="rio" type="checkbox"/>
                                                <label class="ai-c" for="Rio">
                                                    <span class="peer peer-greed">Rio de Janeiro</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class=" p-0 mT-10 col-md-12">
                                        <div class="clearfix"></div>
                                        <div class="datagrid-header peers jc-sb ai-c">
                                            <label>Quais os dias e horários você estará disponível na clínica?</label>
                                        </div>
                                        <br/><br/>

                                        <FisioterapistTimes 
                                        enabled={this.props.data.clinicEnabled} 
                                        intervals={{}} 
                                        id={1} 
                                        onChange={this.props.onChange}/>
                                                                            </div>
                                    <div class=" p-0 mT-10 col-md-12">
                                        <div class="peers ai-c">
                                            <label>Qual é o tempo de consulta na clínica?</label>
                                            <div style={{maxWidth: 70}} class="input-my-time mL-10">
                                                <input value={this.props.data.clinicAppointmentLength} onChange={this.props.onChange} style={{maxWidth:90}} disabled={!this.props.data.clinicEnabled} id="clinicAppointmentLength" class="form-control" type="number" min="30"/>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-md-6 m-0 p-0">
                                    <hr class="clearfix d-n@md+"/>
                                    <div class=" p-0 mT-10 col-md-12 ">
                                        <label>Está disponível para <b>atendimento domiciliar?</b></label>
                                        <div class="peers">
                                            <div class="radio radio-client-default m-0 pX-10 mL-30 mT-20">
                                                <input checked={this.props.data.homeEnabled} onClick={() => this.props.onChange({target:{id:"homeEnabled",value:true}})} type="radio" name="forma-s-dom" id="clinica-radio-1-dom" value="yes"/>
                                                <label for="clinica-radio-1-dom">SIM</label>
                                            </div>
                                            <div class="radio radio-client-default m-0 pX-10 mL-30  mT-20">
                                                <input checked={!this.props.data.homeEnabled} onClick={() => this.props.onChange({target:{id:"homeEnabled",value:false}})} type="radio" name="forma-n-dom" id="clinica-radio-2-dom" value="no"/>
                                                <label for="clinica-radio-2-dom">NÃO</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class=" p-0 mT-10 col-md-12">
                                        <div class="form-group mB-10 col-sm-6">
                                            <label>Qual cidade?</label>
                                            <div class="checkbox checkbox-circle checkbox-client-default ai-c">
                                                <input disabled={!this.props.data.homeEnabled} id="rio-dom" name="rio-dom" type="checkbox"/>
                                                <label class="ai-c" for="rio-dom">
                                                    <span class="peer peer-greed">Rio de Janeiro</span>
                                                </label>
                                            </div>
                                        </div>

                                        <div class="p-0 mT-10 col-sm-6">
                                            <label>Qual Região?</label>
                                            <div class="form-group mB-10 select-size">
                                                <select disabled={!this.props.data.homeEnabled} class="selectpicker form-control">
                                                    <option selected>Zona Sul</option>
                                                </select>

                                            </div>
                                        </div>
                                    </div>
                                    <div class=" p-0 mT-10 col-md-12">
                                        <div class="clearfix"></div>
                                        <div class="datagrid-header peers jc-sb ai-c">
                                            <label>Quais os dias e horários você estará disponível para domiciliar?</label>
                                        </div>
                                    <br/><br/>
                                    <FisioterapistTimes 
                                        enabled={this.props.data.homeEnabled} 
                                        intervals={{}} 
                                        id={0} 
                                    onChange={this.props.onChange}/>

                                    <div class=" p-0 mT-10 col-md-12">
                                        <div class="peers ai-c">
                                            <label>Qual o tempo de consulta domiciliar?</label>
                                            <div style={{maxWidth: 70}} class="input-my-time mL-10">
                                                <input value={this.props.data.homeAppointmentLength} onChange={this.props.onChange} id="homeAppointmentLength" style={{maxWidth:90}} disabled={!this.props.data.homeEnabled} class="form-control" type="number" min="30"/>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/account/FisioterapistAccount.js